import { Component, ViewEncapsulation } from '@angular/core';
import { BcAnalytics } from '../../../common/analytics/analytics.service';
import { AudioService } from '../../../common/audio-service/audio.service';
import { WorkViewEvents, WorkViewEventValues } from '../../../common/common/constants/analytics-enums';

@Component({
  selector: 'app-audio-settings',
  templateUrl: './audio-settings.html',
  styleUrls: ['./audio-settings.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AudioSettingsComponent {
  private _audioEnabled: boolean;

  constructor(private audioService: AudioService, private bcAnalytics: BcAnalytics) {
    this._audioEnabled = audioService.getCurrentNotificationSettings().newChatArrived;
  }

  changeStatus(): void {
    if (this._audioEnabled) {
      this.audioService.muteAudio();
      this.bcAnalytics.eventTrack(WorkViewEvents.SET_AUDIO, { to: WorkViewEventValues.OFF });
    } else {
      this.audioService.unmuteAudio();
      this.bcAnalytics.eventTrack(WorkViewEvents.SET_AUDIO, { to: WorkViewEventValues.ON });
    }
    this._audioEnabled = !this._audioEnabled;
  }

  getIconByStatus(): string {
    return this._audioEnabled ? 'sound-on' : 'sound-off';
  }
}
